import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ProfileSidebar = superstyled({
  name: 'ProfilePanel',
  slot: 'Sidebar',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '0 0 20rem',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flex: 'none',
      minHeight: '200px'
    }
  })
});

export const ProfileSection = superstyled({
  name: 'ProfilePanel',
  slot: 'ProfileSection',
  tag: Box,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column'
  })
});

export const ProfileField = superstyled({
  name: 'ProfilePanel',
  slot: 'ProfileField',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderBottom: `1px solid ${theme.palette.border.main}`,
    '&:last-child': {
      borderBottom: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(0.5)
    }
  })
});

export const ProfileFieldLabel = superstyled({
  name: 'ProfilePanel',
  slot: 'ProfileFieldLabel',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
    minWidth: 0
  })
});

export const ProfileFieldValue = superstyled({
  name: 'ProfilePanel',
  slot: 'ProfileFieldValue',
  tag: Text,
  styles: () => ({
    textAlign: 'left',
    wordBreak: 'break-word'
  })
});

export const ButtonsContainer = superstyled({
  name: 'ProfilePanel',
  slot: 'ButtonsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});
